import { defineComponent as _defineComponent } from 'vue'
import HeaderCustomer from "@/components/HeaderCustomer.vue";
  import { onMounted, ref } from "vue";
  import router from "@/router";
  import store from "@/store";
  import { isLogged } from "@/features/useUser";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EOIWaitlistConfirmation',
  setup(__props, { expose: __expose }) {
  __expose();

  const estateId = ref(router.currentRoute.value.params.estateId);
  const estate = ref({});
  const loading = ref(true);

  onMounted(() => {
    store
      .dispatch("estate/getEstate", estateId.value)
      .then((res) => {
        estate.value = res.data;
      })
      .finally(() => {
        loading.value = false;
      });
  });

const __returned__ = { estateId, estate, loading, HeaderCustomer, onMounted, ref, get router() { return router }, get store() { return store }, get isLogged() { return isLogged } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})